import { render } from "./Test.vue?vue&type=template&id=40246169"
import script from "./Test.vue?vue&type=script&lang=js"
export * from "./Test.vue?vue&type=script&lang=js"

import "./Test.vue?vue&type=style&index=0&id=40246169&lang=scss"
script.render = render

export default script